<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4>Sesiones</h4>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">FechaReg</th>
          <th scope="col">DireccionIp</th>
          <th scope="col">UserAgent</th>
          <th scope="col">UsuarioNombre</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sesionerr in datosPaginados" :key="sesionerr.idSesionErr">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(sesionerr.idSesionErr)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(sesionerr.idSesionErr)" title="Editar">edit_square</i></td>
          <td>{{getFormattedDate(sesionerr.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{sesionerr.direccionIp}}</td>
          <td>{{sesionerr.userAgent}}</td>
          <td>{{sesionerr.usuarioNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteSesionErr(sesionerr.idSesionErr)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idSesionErr" class="form-label">IdSesionErr</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idSesionErr" name="idSesionErr" v-model="datoSesionErr.idSesionErr" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoSesionErr.idUsuario" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoSesionErr.fechaReg" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccionIp" class="form-label">DireccionIp</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="direccionIp" name="direccionIp" v-model="datoSesionErr.direccionIp" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="userAgent" class="form-label">UserAgent</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="userAgent" name="userAgent" v-model="datoSesionErr.userAgent" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarSesionErr" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditSesionErr" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import dateFormat from '@/modules/dateFormat.js';

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      sesionerrs : [],
      datoSesionErr : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas(){
      return Math.ceil(this.sesionerrs.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwsesionerrs/nombre/'+this.nombreBusqueda).then(response=>{
          this.sesionerrs=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.sesionerrs.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwsesionerrs').then(response=>{
      this.sesionerrs=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.sesionerrs.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idUsuario'
        ,'direccionIp'
        ,'userAgent'
      ];
      const requiredFieldsText = [
        'idUsuario'
        ,'direccionIp'
        ,'userAgent'
      ];
      return validarForm(this.datoSesionErr, requiredFields, requiredFieldsText);
    },
    async guardarSesionErr(){
      if(this.validarForm() === 1){
        try {
          this.datoSesionErr.idUsuario = window.sessionStorage.getItem("idUsuario");
          await api.post('/sesionerrs', this.datoSesionErr)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "SesionErr creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditSesionErr(){
      if(this.validarForm() === 1){
        try {
          await api.post('/sesionerrs', this.datoSesionErr)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "SesionErr creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoSesionErr={}
      this.titulo   = 'Crear Sesiones'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idSesionErr){
      this.modalWindow = true
      if(idSesionErr != null){    
           api.get('/vwsesionerrs/'+idSesionErr).then(resp=>{
          this.datoSesionErr = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Sesiones'
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idSesionErr){
      if(idSesionErr != null){
        this.$router.push('/sesionerrmd/'+idSesionErr)
      }
    },
    async deleteSesionErr (idSesionErr) {
      try{
        await api.delete('/sesionerrs/'+idSesionErr)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>
